import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-content" }
const _hoisted_3 = { class: "breadcrumb" }
const _hoisted_4 = { class: "breadcrumb-item inline-block relative text-sm mx-[11px] ltr:first:ml-0 rtl:first:mr-0 ltr:last:mr-0 rtl:last:ml-0" }
const _hoisted_5 = { class: "relative click-to-show-hide-code" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ol", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createVNode(_component_RouterLink, {
            to: "/dashboard",
            class: "inline-block relative ltr:pl-[22px] rtl:pr-[22px] transition-all hover:text-primary-500"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "material-symbols-outlined absolute ltr:left-0 rtl:right-0 !text-lg -mt-px text-primary-500 top-1/2 -translate-y-1/2" }, " home ", -1),
              _createTextVNode(" Dashboard ")
            ])),
            _: 1,
            __: [2]
          })
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("li", { class: "breadcrumb-item inline-block relative text-sm mx-[11px] ltr:first:ml-0 rtl:first:mr-0 ltr:last:mr-0 rtl:last:ml-0" }, " UI Elements ", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("li", { class: "breadcrumb-item inline-block relative text-sm mx-[11px] ltr:first:ml-0 rtl:first:mr-0 ltr:last:mr-0 rtl:last:ml-0" }, " Breadcrumb ", -1))
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "mt-[15px] md:mt-[20px]" }, null, -1)),
      _createElementVNode("button", {
        type: "button",
        class: "clickToSeeCodeBtn inline-block text-black dark:text-white font-semibold",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleCode && _ctx.toggleCode(...args)))
      }, _toDisplayString(_ctx.showCode ? "Click to Hide Code:" : "Click to See Code:"), 1),
      _withDirectives(_createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "absolute text-lg ltr:right-[20px] rtl:left-[20px] top-[20px] transition-all text-primary-500 copy-btn w-[35px] h-[35px] inline-block border border-primary-500 bg-white rounded-sm dark:bg-[#0c1427]",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copyCode && _ctx.copyCode(...args))),
          type: "button"
        }, _cache[5] || (_cache[5] = [
          _createElementVNode("i", { class: "ri-file-copy-line" }, null, -1)
        ])),
        _cache[6] || (_cache[6] = _createElementVNode("pre", { class: "line-numbers !mt-[15px] !py-0 !px-[20px] md:!px-[25px] mb-0" }, [
          _createTextVNode(""),
          _createElementVNode("code", {
            class: "language-markup",
            id: "copyCodes"
          }, "\n<ol class=\"breadcrumb\">\n<li class=\"breadcrumb-item inline-block relative text-sm mx-[11px] ltr:first:ml-0 rtl:first:mr-0 ltr:last:mr-0 rtl:last:ml-0\">\n<RouterLink to=\"/dashboard\" class=\"inline-block relative ltr:pl-[22px] rtl:pr-[22px] transition-all hover:text-primary-500\">\n<i class=\"material-symbols-outlined absolute ltr:left-0 rtl:right-0 !text-lg -mt-px text-primary-500 top-1/2 -translate-y-1/2\">\n    home\n</i>\nDashboard\n</RouterLink>\n</li>\n<li class=\"breadcrumb-item inline-block relative text-sm mx-[11px] ltr:first:ml-0 rtl:first:mr-0 ltr:last:mr-0 rtl:last:ml-0\">\nUI Elements\n</li>\n<li class=\"breadcrumb-item inline-block relative text-sm mx-[11px] ltr:first:ml-0 rtl:first:mr-0 ltr:last:mr-0 rtl:last:ml-0\">\nBreadcrumb\n</li>\n</ol>\n"),
          _createTextVNode("\n")
        ], -1))
      ], 512), [
        [_vShow, _ctx.showCode]
      ])
    ])
  ]))
}